export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5008.832c0c00.jpg";